import React from 'react';
import FullScreenDataContainer
  from 'Components/ComponentLibrary/Components/Uncategorized/DataContainer/FullScreenDataContainer';
import useHomeContext from 'Context/HomeContext';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import fr from 'facet-rest';
import { navigateTo } from 'Helpers/Redirect';
import Content from './Content';

const Container = (props) => {
  const { homeResource } = useHomeContext();

  const [authColl, setAuthColl] = React.useState(null);
  const [errors, setErrors] = React.useState(null);

  useComponentDidMount(async () => {
    if (homeResource.relationship(fr.relationships.user.name)) {
      navigateTo('/');
      return;
    }

    try {
      const coll = await homeResource.relationship(fr.relationships.resetPassword.name).link('related').get();
      setAuthColl(coll);
    } catch (err) {
      setErrors(err);
    }
  });

  return (
    <FullScreenDataContainer
      component={Content}
      componentProps={{
        ...props,
        authCollection: authColl,
      }}
      loading={!authColl}
      loadingError={errors}
    />
  );
};

export default Container;
